import {
  Chart as ChartJS,
  Filler,
  Legend,
  LineElement,
  PointElement,
  RadialLinearScale,
  Tooltip,
} from "chart.js";
import { Radar } from "react-chartjs-2";

interface ResultRadarProps {
  data: {
    label: string;
    points: number | null;
  }[];
}

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
);

function ResultRadar({ data: result }: ResultRadarProps) {
  const labels: string[] = [];
  const data: number[] = [];
  result.forEach(({ label, points }) => {
    labels.push(label);
    data.push(points ?? 0);
  });

  if (labels.length < 3) return null;

  return (
    <Radar
      options={{
        plugins: {
          legend: {
            display: false,
          },
          datalabels: {
            align: "end",
            font: {
              size: 14,
            },
          },
        },
        scales: {
          r: {
            min: 0,
            max: 100,
            ticks: {
              stepSize: 20,
              z: 1,
              backdropColor: "rgba(255, 255, 255, 0.5)",
              backdropPadding: 4,
              showLabelBackdrop: true,
            },
            pointLabels: {
              padding: 20,
              font: {
                size: 16,
              },
            },
          },
        },
      }}
      data={{
        labels,
        datasets: [
          {
            label: "Score",
            data,
            backgroundColor: "rgba(0, 0, 0, 0.1)",
            borderColor: "rgb(8, 145, 178)",
            borderWidth: 2,
          },
        ],
      }}
    />
  );
}

export default ResultRadar;
